import { FiArrowRight } from "react-icons/fi";

export default function LinkWithDivider(props: {
	title: string;
	isFirstItemOfGroup?: boolean;
	href?: string;
	borderX?: boolean;
	showArrowWithoutHref?: boolean;
	onClick?: () => void;
}) {
	const { title, isFirstItemOfGroup, href, borderX, showArrowWithoutHref, onClick } = props;

	return (
		<div
			className={`border-y border-black bg-white ${isFirstItemOfGroup ? "" : "!border-t-0"} px-4 ${
				borderX ? "border-x" : ""
			}`}
		>
			{!href && (
				// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
				<div
					className={`flex w-full items-center justify-between py-4 text-left text-gray-800 antialiased ${
						onClick ? "cursor-pointer" : ""
					}`}
					onClick={onClick}
				>
					<span>{title}</span>
					{showArrowWithoutHref && <FiArrowRight size={"20px"} />}
				</div>
			)}
			{href && (
				<a href={href} className="flex w-full items-center justify-between py-4 text-left text-gray-800 antialiased">
					<span>{title}</span>
					<FiArrowRight size={"20px"} />
				</a>
			)}
		</div>
	);
}
